"use strict";
import React from "react";
import "art/modes/dom";
import { Group, Pattern } from "react-art";
import Rectangle from "react-art/shapes/rectangle";
import { getDisplayName } from "./utils";
import Vector from "immutable-vector2d";
import "../../api/api";
const StampElement = (props) => {
  return /* @__PURE__ */ React.createElement(Group, { x: props.x, y: props.y }, /* @__PURE__ */ React.createElement(
    Rectangle,
    {
      width: props.width,
      height: props.height,
      cursor: props.annotating ? "move" : "default",
      stroke: props.selected ? "#aaa" : "#ddd",
      strokeWidth: props.annotating ? 2 : 0,
      fill: new Pattern(props.annotationStampUrl, props.width, props.height, 0, 0)
    }
  ));
};
StampElement.calculateDragPoints = function(x, y, width, height) {
  return [
    { x, y },
    { x: x + width, y },
    { x: x + width, y: y + height },
    { x, y: y + height }
  ].map(Vector.fromObject);
};
StampElement.typeID = "Stamp";
StampElement.displayName = getDisplayName(StampElement);
StampElement.getBoundingBox = function(dragPoints) {
  const multipliers = [
    [-1, -1],
    [1, -1],
    [1, 1],
    [-1, 1]
  ];
  return dragPoints.map((point, idx) => {
    return [point.x + multipliers[idx][0], point.y + multipliers[idx][1]];
  });
};
export default StampElement;
